import { StaffMember } from '@ice-web-app/assets';
import { DsTypography } from '@ice-web-app/designSystem';
import { useTranslation } from '@ice-web-app/shared-hooks';
import { useCurrentUserStore } from '@ice-web-app/shared-store';
import { Box, Stack } from '@mui/material';
import { Dispatch, FC, SetStateAction, useEffect, useRef, useState } from 'react';
import SidebarIconFrame from '../SidebarIconFrame';
import MemberMenu from './MemberMenu';

interface Props {
  menu: 'ecosystem' | 'microSystem' | 'member' | 'none';
  setMenu: Dispatch<SetStateAction<'ecosystem' | 'microSystem' | 'member' | 'none'>>;
}

const Member: FC<Props> = ({ menu, setMenu }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setMenu('member');
  };
  const { currentUserType } = useCurrentUserStore();

  useEffect(() => {
    if (menu === 'member') setAnchorEl(ref.current);
  }, [menu]);

  return (
    <>
      <Stack justifyContent="center" alignItems="center" gap={3.25}>
        <Box ref={ref}>
          <SidebarIconFrame handleClick={handleClick}>
            <StaffMember />
          </SidebarIconFrame>
        </Box>
        <DsTypography
          variant="body2_500"
          sx={{
            fontSize: '0.625rem',
            textAlign: 'center',
            whiteSpace: 'pre-wrap',
            display: 'block',
            wordSpacing: '100vw',
          }}
        >
          {t(currentUserType)}
        </DsTypography>
      </Stack>
      <MemberMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} setMenu={setMenu} />
    </>
  );
};
export default Member;
